import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/CaretRight.svg'

export const IconCaretRight = IconSVG as IconComponent
